import { render, staticRenderFns } from "./UITabs.vue?vue&type=template&id=17c31a64"
import script from "./UITabs.vue?vue&type=script&lang=js"
export * from "./UITabs.vue?vue&type=script&lang=js"
import style0 from "./UITabs.vue?vue&type=style&index=0&id=17c31a64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports